import { css } from "styled-components";

export const GlobalClasses = css`
  .center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .has-scrollbar {
    will-change: scroll-position;
    scroll-behavior: smooth;
    overflow: hidden overlay;
    &::-webkit-scrollbar {
      width: 4px;
      visibility: hidden;
    }
    &:hover::-webkit-scrollbar {
      width: 4px;
      visibility: visible;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 12px;
      /* background: hsla(0, 0%, 7%, 0.75); */
    }
  }
  .has-scrollbar-ytb {
    will-change: scroll-position;
    scroll-behavior: smooth;
    overflow: hidden overlay;
    &::-webkit-scrollbar {
      width: 4px;
      visibility: hidden;
    }
    &:hover::-webkit-scrollbar {
      width: 4px;
      visibility: visible;
    }
    &:hover::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 7%, 0.75);
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 12px;
    }
  }
  .tippy-box {
    font-size: 12px;
  }
  .tippy-content {
    padding-top: 3px;
    padding-bottom: 3px;
  }
`;
